import React, { useState, useEffect } from 'react';
import '../../../App.css';
import { db, promotions_col_name } from '../../../firebase';

import {
    collection,
    addDoc,
    serverTimestamp,
    query,
    where,
    getDocs,
    deleteDoc,
    doc,
    setDoc
} from 'firebase/firestore';

const ManagePromotions = () => {
    const promotionsID = 'promotions-id-001';
    const [promotionTitle, setPromotionTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [existingPromotions, setExistingPromotions] = useState([]);

    const fetchPromotions = async () => {
        try {
            const q = query(collection(db, promotions_col_name));
            const snapshot = await getDocs(q);
            const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
            setExistingPromotions(list);
        } catch (err) {
            console.error('Error fetching promotions:', err);
        }
    };

    useEffect(() => {
        fetchPromotions();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const trimmed = promotionTitle.trim();
        if (!trimmed) {
            setError('Please enter a promotion title.');
            return;
        }

        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            await setDoc(doc(db, promotions_col_name, promotionsID), {
                title: promotionTitle,
                createdAt: serverTimestamp()
            });

            setSuccess(true);
            setPromotionTitle('');
            fetchPromotions();
            setTimeout(() => setSuccess(false), 3000);
        } catch (err) {
            console.error('Error adding promotion:', err);
            setError('Failed to add promotion. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this promotion?')) return;
        try {
            await deleteDoc(doc(db, promotions_col_name, id));
            fetchPromotions();
        } catch (err) {
            console.error('Error deleting promotion:', err);
        }
    };

    return (
        <section className="admin-section fade-in">
            <h2>Add Promotions</h2>
            <form className="admin-form" onSubmit={handleSubmit}>
                <div className="add-products-form-grid">
                    <div className="form-group">
                        <label>Promotion Title</label>
                        <input
                            type="text"
                            placeholder="e.g. ramadhan offer sale"
                            value={promotionTitle}
                            onChange={(e) => setPromotionTitle(e.target.value)}
                            maxLength={50}
                            required
                        />
                    </div>
                </div>
                <button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? 'Adding...' : 'Add Promotion'}
                </button>
            </form>

            {success && (
                <div
                    className="alert alert-success"
                    style={{
                        padding: '10px',
                        backgroundColor: '#d4edda',
                        color: '#155724',
                        marginTop: '15px',
                        marginBottom: '15px',
                        borderRadius: '4px'
                    }}
                >
                    Promotion added successfully!
                </div>
            )}

            {error && (
                <div
                    className="alert alert-danger"
                    style={{
                        padding: '10px',
                        backgroundColor: '#f8d7da',
                        color: '#721c24',
                        marginTop: '15px',
                        marginBottom: '15px',
                        borderRadius: '4px'
                    }}
                >
                    {error}
                </div>
            )}

            <div className="existing-items">
                <h3>Existing Promotions</h3>
                <ul className="item-list">
                    {existingPromotions.length === 0 ? (
                        <li>No promotions yet.</li>
                    ) : (
                        existingPromotions.map((promotion) => (
                            <li key={promotion.id}>
                                {promotion.title}{' '}
                                <button
                                    type="button"
                                    className="btn-sm btn-delete"
                                    onClick={() => handleDelete(promotion.id)}
                                >
                                    Delete
                                </button>
                            </li>
                        ))
                    )}
                </ul>
            </div>
        </section>
    );
};

export { ManagePromotions };
